var map = {
	"./collect.js": "a885",
	"./column.js": "bd3b",
	"./config.js": "e9aa",
	"./content.js": "c8e8",
	"./interact.js": "13e5",
	"./login.js": "800d",
	"./message.js": "1f31",
	"./statistics.js": "f265",
	"./system.js": "fca1",
	"./vip.js": "8b2e",
	"./wechat.js": "e05d",
	"./weibo.js": "b076",
	"./workplace.js": "2944"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d2ec";